import React from "react";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "Do you really want to proceed?",
  yesText = "Yes",
  noText = "No",
}) {
  if (!open) return null;

  return (
    <>
      {/* Overlay */}
      <div className="confirm-overlay" onClick={onClose}></div>

      {/* Modal Box */}
      <div className="confirm-modal">
        <h2 className="confirm-title">{title}</h2>
        <p className="confirm-message">{message}</p>

        <div className="confirm-buttons">
          {noText && (
            <button className="confirm-btn no-btn" onClick={onClose}>
              {noText}
            </button>
          )}
          {yesText && (
            <button
              className="confirm-btn yes-btn"
              onClick={() => {
                onConfirm?.();
                onClose();
              }}
            >
              {yesText}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
